import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { GroceryCaseIncidentEntry } from '../../../../types';

type CellParams = ICellRendererParams<GroceryCaseIncidentEntry> & {
  viewCallback: (params: CellParams, item: GroceryCaseIncidentEntry) => void;
};

@Component({
  selector: 'app-pan-grocery-ctp-view-action-cell',
  imports: [UiModule, MatTooltipModule],
  templateUrl: './grocery-ctp-view-action-cell.component.html',
})
export class GroceryCtpViewActionCellComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
